module.exports = {
    everydayRewards: {
        cardName: 'Woolworths Rewards',
        enableRewardsPlus: false,
        enableProjectPortugal: false,
        forgottenPasswordRewardsLink: 'https://www.woolworthsrewards.com.au/index.html#/forgot-password',
        isRewardsPlus: false,
        rewardsBannerTitle: 'Your Woolworths Rewards Card has been linked.',
        rewardsBannerSubtitle: 'Start shopping to enjoy all your benefits.',
        rewardsBannerButtonText: 'Get Started',
        rewardsLoginPromotionText: 'When you add your card, you can see your favourite weekly picks, start earning points and more.',
        rewardsLoginValidationErrorTitle: 'Adding your Woolworths Rewards card was not successful.',
        rewardsLoginServerError: 'Your specified Woolworths Reward card number has not been accepted. Please check your entry or call the Customer Service Team on 1800 000 610 for assistance.',
        rewardsLoginSubmitButton: 'Link my card',
        rewardsLoginForgotPasswordLinkText: 'Forgotten your password?',
        rewardsLoginGreyBackgroundText: 'This page will refresh once your accounts are successfully linked in the Woolworths Rewards browser.',
        rewardsMembershipAppliedMessage: 'Rewards membership applied',
        rewardsNumberLoginTitle: 'Woolworths Rewards Number',
        rewardsPasswordHintText: 'Please enter the same password you use to access your Woolworths Reward card account on www.woolworthsrewards.com.au',
        rewardsPlusBenefitTiles: '[{"iconClass": "iconww-SetTimeDelivery", "title": "Free Delivery", "subtitle": "On Woolworths, BWS and Dan Murphy\'s orders"}, {"iconClass": "iconww-SetTime", "title": "Priority Timeslot", "subtitle": "Prioritised choice of delivery timeslots"}, {"iconClass": "iconww-Specials", "title": "Double Points", "subtitle": "For every $ spent on fresh food - instore, and online (Delivery & Pick up)"}]',
        rewardsPlusBenefitsTitle: 'Additional Rewards Benefits',
        rewardsPlusFooterText: 'Please contact our Customer Team on <strong>1800 1000 610</strong> or email us at <a href="mailto:rewards@woolworths.com.au">rewards@woolworths.com.au</a> if you have any questions or want to cancel your trial.',
        rewardsPlusFreeDeliveryMessage: 'You saved {DeliveryFee} on delivery',
        rewardsPlusTitle: 'My additional benefits',
        rewardsPointsFuelDiscountsSubtitle: '{X} saved on fuel since {Y}',
        rewardsPointsFuelDiscountsTitle: 'Current Fuel Discounts^',
        rewardsPointsLifetimeRedeemedSubtitle: 'Since joining',
        rewardsPointsLifetimeRedeemedTitle: 'Woolworths Dollars Redeemed',
        rewardsPointsSaveForLaterChristmasIcon: 'iconww-SaveForLaterChristmasIcon',
        rewardsPointsSaveForLaterChristmasSubtitle: 'Available from {X}',
        rewardsPointsSaveForLaterChristmasTitle: 'Saved for Christmas',
        rewardsPointsSaveForLaterChristmasEmptyText: 'You\'re saving for Christmas',
        rewardsPointsSaveForLaterDefaultIcon: 'iconww-SaveForLaterDefault',
        rewardsPointsSaveForLaterDefaultSubtitle: 'Automatically save on your next shop',
        rewardsPointsSaveForLaterDefaultTitle: 'Off your next shop',
        rewardsPointsSaveForLaterQuarterlyOffIcon: 'iconww-SaveForLaterQuarterlyOff',
        rewardsPointsSaveForLaterQuarterlyOffSubtitle: '{X} Qantas Points will be transferred on {Y}',
        rewardsPointsSaveForLaterQuarterlyOffTitle: 'Woolworths Dollars to Convert',
        rewardsPointsSaveForLaterQuarterlyOffEmptyText: 'You\'re saving for Qantas Points',
        rewardsPointsServerError: 'There was an issue loading your rewards points. Please try again later.',
        rewardsPointsTitle: 'My Rewards Points',
        rewardsPointsTotalMaximum: 2000,
        rewardsPointsTotalSubtitle: 'Earn {X} more to get $10 off your next shop*',
        rewardsPointsQantasTotalSubtitle: '2000 Woolworths Points = 1000 Qantas Points',
        rewardsPointsTotalTitle: 'Points',
        rewardsStatusAcceptedText: 'Your Woolworths Rewards card has been accepted',
        rewardsStatusAdditionalBenefitsTitle: 'Your Rewards+ account is:',
        rewardsStatusRemoveCardErrorMessage: 'There was an issue removing your card. Please try again later.',
        rewardsStatusTitle: 'My Woolworths Rewards card',
        rewardsPlusUrlToMyDanMurphysPage: 'https://test.my.woolworthsrewards.com.au/coa/#/nbpoi/',
        rewardsSignUpTitleText: 'Your Rewards account has been created',
        rewardsSignUpSubText: 'Check your email for more information about your new account',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/everyday-rewards.js